export const MAPS_API_KEY = process.env.REACT_APP_MAPS_API_KEY!;
export const LIBRARIES = ["places"] as any;
export const BASE_URL = process.env.REACT_APP_BASE_URL!;